<template lang="html">
  <div id="logoutPage">
  {{ message }}
  </div>
</template>
<script>
import {
  LOGOUT,
  SHOW_ONLINE
} from '@/vuex/mutation_types'

export default {
  data () {
    return {
      message: 'ログアウトしています…'
    }
  },
  methods: {
    doLogout () {
      this.$store.dispatch('logout').then(
        () => {
          this.message = 'ログアウトしました'
          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        }
      ).catch(
        (err) => {
          console.log('エラーが発生しました． :' + err)
          return
        }
      )
      this.$store.commit(SHOW_ONLINE, false) // オンライン表示を解除
      this.$store.commit(LOGOUT)
    }
  },
  created () {
    this.doLogout()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Logout.vue?7c255536